<template>
  <div>
    <div class="list-group position-relative mb-5 mt-4" v-if="!loading && !hasContent">
      <div class="upcoming-post list-group-item py-3 px-4 my-2
        border border-left-0 rounded-lg align-items-center d-flex"
        style="min-height: 92px" :style="{'--bgColor': '#3D5AFE'}">
        <p class="h5 text-muted mb-0">{{ noData }}</p>
      </div>
    </div>
    <div class="list-group position-relative mb-5 mt-4" v-else>
      <loading :active.sync="loading" :is-full-page="false"></loading>
      <a href="#" class="upcoming-post list-group-item list-group-item-action
        py-3 px-4 my-2 border border-left-0 rounded-lg list-group-item"
        v-for="(fake, index) in num" :key="'upcomingfake' + index"
        style="min-height: 92px" :style="{'--bgColor': '#3D5AFE'}">
      </a>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    loading: Boolean,
    num: Number,
    hasContent: Boolean,
    noData: String,
  },
};
</script>
<style scoped>
.upcoming-post {
  position: relative;
  overflow: hidden;
}
.upcoming-post::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 4px;
  background-color: var(--bgColor)
}
</style>
